<script lang="ts">
import { defineComponent, computed, PropType } from 'vue';

export default defineComponent({
    name: 'IconAnimatedCheckMark',
    props: {
        /**
         * Размер иконки: число (px) или строка с любыми CSS-единицами, например "2rem", "50%" и т.д.
         */
        size: {
            type: [Number, String] as PropType<number | string>,
            default: 56,
        },
    },
    setup(props) {
        const dimension = computed(() =>
            typeof props.size === 'number'
                ? `${props.size}px`
                : props.size
        );
        return { dimension };
    },
});
</script>

<template>
    <svg
        class="checkmark"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 52 52"
        :style="{ width: dimension, height: dimension }"
    >
        <!-- обводка круга -->
        <circle
            class="checkmark__outline"
            cx="26"
            cy="26"
            r="25"
            fill="none"
        />
        <!-- заливка круга -->
        <circle
            class="checkmark__fill"
            cx="26"
            cy="26"
            r="25"
        />
        <!-- галочка -->
        <path
            class="checkmark__check"
            d="M14.1 27.2l7.1 7.2 16.7-16.8"
            fill="none"
        />
    </svg>
</template>

<style scoped lang="scss">
.checkmark {
    display: block;
}

/* 1) Рисуем обводку */
.checkmark__outline {
    stroke: #7ac142;
    stroke-width: 2;
    stroke-dasharray: 157;      /* ≈ 2πr */
    stroke-dashoffset: 157;
    animation: draw-outline 0.6s ease-out forwards;
}

/* 2) Заливаем круг (scale от 0 до 1) */
.checkmark__fill {
    fill: #7ac142;

    /* важно для корректного центрирования при любых размерах */
    transform-box: fill-box;
    transform-origin: center;
    transform: scale(0);

    /* стартуем сразу по окончании обводки */
    animation: fill-circle 0.4s ease-in-out 0.6s forwards;
}

/* 3) Рисуем галочку поверх */
.checkmark__check {
    stroke: #fff;
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 100;      /* больше длины пути */
    stroke-dashoffset: 100;
    animation: draw-check 0.3s ease-out 1.0s forwards;
    /* задержка 1.0s = 0.6 + 0.4 */
}

@keyframes draw-outline {
    to { stroke-dashoffset: 0; }
}

@keyframes fill-circle {
    to { transform: scale(1); }
}

@keyframes draw-check {
    to { stroke-dashoffset: 0; }
}
</style>
